import * as Yup from 'yup';

export const loginSchema = Yup.object().shape({
    username: Yup.string().required('Email Id/Mobile No is required'),
    password: Yup.string().required('Password is required'),
});

export const signUpSchema = Yup.object().shape({
    name: Yup.string().required('First Name is required'),
    last_name: Yup.string().required('Last Name is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    password: Yup.string().required('Password is required')
        .min(8, 'Password must be at least 8 characters long')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/[0-9]/, 'Password must contain at least one number')
        .matches(/[@$!%*?&#]/, 'Password must contain at least one special character'),
    day: Yup.number().required('Day is required').min(1).max(31),
    month: Yup.number().required('Month is required').min(1).max(12),
    year: Yup.number().required('Year is required').min(1900).max(new Date().getFullYear()),
    maritalStatus: Yup.string().required('Marital Status is required'),
    height: Yup.string().required('Height is required'),
    mobileNumber: Yup.string()
        .required('Mobile number is required')
        .matches(/^[0-9]{10}$/, 'Mobile number must be exactly 10 digits'),
    register_platform: Yup.string().nullable(),
    registerby: Yup.string().required('Profile created by is required'),
    gender: Yup.string().required('Gender is required'),
    terms: Yup.bool().oneOf([true], 'You must accept the terms and conditions'),
    register_platform: Yup.string().nullable(),
});

export const professionalDetailSchema = Yup.object().shape({
    education: Yup.string().required('Education field is required'),
    educationDetail: Yup.string().nullable(),
    occupation: Yup.string().required('Profession field is required'),
    occupationDetail: Yup.string().nullable(),
    income: Yup.string().nullable(),
    country: Yup.string().required('Country field is required'),
    state: Yup.string().required('State field is required'),
    city: Yup.string().required('City field is required'),
    tokan: Yup.string().nullable(),
    user_id: Yup.string().nullable(),
});

export const contactReligionDetailSchema = Yup.object().shape({

    streetAddress: Yup.string().nullable(),
    pincode: Yup.string()
        .matches(/^[0-9]{6}$/, 'Pincode must be exactly 6 digits')
        .nullable(),
    area: Yup.string().nullable(),
    city: Yup.string().required('City is required'),
    state: Yup.string().required('State is required'),
    country: Yup.string().required('Country is required'),
    caste: Yup.string()
        .required('Caste is required'),
    religion: Yup.string().required('Religion is required'),
    citizenship: Yup.string().nullable(),
    domain: Yup.string().required('Domain is required'),
    user_id: Yup.string().nullable(),
    tokan: Yup.string().nullable(),
    specialmobileNumber: Yup.string()
        .matches(/^[0-9]+$/, 'Special Mobile Number must be numeric')
        .min(10, 'Mobile Number must be at least 10 digits')
        .nullable(),
});


export const familyDetailSchema = Yup.object().shape({
    familyValue: Yup.string()
        .required('Family value is required'),
    familyStatus: Yup.string()
        .required('Family status is required'),
    familyType: Yup.string()
        .required('Family Type is required'),
    fatherName: Yup.string()
        .required('Father Name is required'),
    motherName: Yup.string()
        .required('Mother Name is required'),
    fatherProfessions: Yup.string()
        .notRequired(),
    motherProfession: Yup.string()
        .notRequired(),
    marriedBrothers: Yup.number()
        .typeError('Married Brothers must be a number')
        .integer('Married Brothers must be a whole number')
        .min(0, 'Married Brothers cannot be negative')
        .notRequired('Number of Married Brothers is required'),
    unMarriedBrothers: Yup.number()
        .typeError('Unmarried Brothers must be a number')
        .integer('Unmarried Brothers must be a whole number')
        .min(0, 'Unmarried Brothers cannot be negative')
        .notRequired('Number of Unmarried Brothers is required'),
    marriedSister: Yup.number()
        .typeError('Married Sisters must be a number')
        .integer('Married Sisters must be a whole number')
        .min(0, 'Married Sisters cannot be negative')
        .notRequired('Number of Married Sisters is required'),
    unMarriedSister: Yup.number()
        .typeError('Unmarried Sisters must be a number')
        .integer('Unmarried Sisters must be a whole number')
        .min(0, 'Unmarried Sisters cannot be negative')
        .notRequired('Number of Unmarried Sisters is required'),
    familyOrigin: Yup.string().optional('Family native Place is required'),
    aboutFamily: Yup.string().nullable(),
    tokan: Yup.string().nullable(),
    user_id: Yup.string().nullable(),
});

export const sendOtpSchema = Yup.object().shape({
    mobileNumber: Yup.string()
        .required('Mobile number is required')
        .matches(/^[0-9]{10}$/, 'Mobile number must be exactly 10 digits'),
    tokan: Yup.string().nullable(),
    user_id: Yup.string().nullable(),
})
export const basicDetailEditSchema = Yup.object().shape({
    name: Yup.string().required('First Name is required'),
    last_name: Yup.string().required('Last Name is required'),
    date_of_birth: Yup.string().required('DAte Of Birth is required'),
    age: Yup.number().required('Age is required').min(18, 'Age must be at least 18').max(100, 'Age must be less than or equal to 100'),
    gender: Yup.string().required('Gender is required'),
    maritalStatus: Yup.string().required('Marital Status is required'),
    height: Yup.string().required('Height is required'),
    bloodGroup: Yup.string().required('Blood Group is required'),
    about_me: Yup.string().nullable(),
    no_of_Children: Yup.string().nullable(),
    childrenLivingStatus: Yup.string().nullable(),
    registerBy: Yup.string().required('Register By is required')
    // no_of_Children: Yup.string().when('maritalStatus', {
    //     is: (status) => ['2', '3', '4', '5'].includes(status), // Customize based on your logic
    //     then: Yup.string().required('No of Children is required'),
    //     otherwise: Yup.string(),
    //   }),
    //   childrenLivingStatus: Yup.string().when('no_of_Children', {
    //     is: 'yes',
    //     then: Yup.string().required('Children living status is required'),
    //     otherwise: Yup.string(),
    //   }),
});

export const professionalDetailEditSchema = Yup.object().shape({
    education: Yup.string()
        .required('Education is required'),
    educationDetail: Yup.string()
        .notRequired(),
    occupation: Yup.string()
        .required('Profession is required'),
    occupationDetail: Yup.string()
        .notRequired(),
    income: Yup.string()
        .required('Income is required'),
    residingCountry: Yup.string()
        .required('Residing Country is required'),
    residingState: Yup.string()
        .required('Residing State is required'),
    residingCity: Yup.string()
        .required('Residing City is required'),
});

export const contactDetailEditSchema = Yup.object().shape({
    Address: Yup.string().notRequired(),
    Area: Yup.string().notRequired(),
    Pincode: Yup.string().notRequired(),
    Country: Yup.string().required('Country is required'),
    State: Yup.string().required('State is required'),
    City: Yup.string().required('City is required'),
    Citizenship: Yup.string().notRequired(),
    nationality: Yup.string().notRequired(),
    phoneNumber: Yup.string().notRequired(),
});

export const physicalDetailsSchema = Yup.object().shape({
    Weight: Yup.string().required('Weight is required'),
    // Weight_ids: Yup.string().required('Weight ID is required'),
    Physical_Status: Yup.string().required('Physical Status is required'),
    Body_Type: Yup.string().required('Body Type is required'),
    Complexion: Yup.string().required('Complexion is required'),
    Eating_Habits: Yup.string().required('Eating Habits are required'),
    Drinking_Habits: Yup.string().required('Drinking Habits are required'),
    Smoking_Habits: Yup.string().required('Smoking Habits are required'),
});

export const religionDetailEditSchema = Yup.object().shape({
    domain: Yup.string().required('Domain is required'),
    religion: Yup.string().required('Religion is required'),
    Community: Yup.string().required('Community is required'),
    Sub_Community: Yup.string().notRequired(),
    gothram: Yup.string().notRequired(),
    star: Yup.string().notRequired(),
    padam: Yup.string().notRequired(),
    sevvaiDosham: Yup.string().notRequired(),
    Mother_Tongue: Yup.string().notRequired()
});

export const partnerBasicDetailEditSchema = Yup.object().shape({
    partner_age_From: Yup.number().min(18, "Minimun age is 18").required('Parter age from is required'),
    partner_age_To: Yup.number().min(18, "Minimun age is 18").required('Parter age to is required'),
    partnerHeightFrom: Yup.string().required("Partner height from is required"),
    partnerHeightTo: Yup.string().required("Partner height to is required"),
    partnerMaritalStatus: Yup.array()
        .of(Yup.string()) // Ensures each item in the array is a string
        .min(1, 'Select at least one marital status')
        .required('Marital Status is required'),
    no_of_Children: Yup.string().optional(),
    physicalStatus: Yup.string().notRequired()
});

export const partnerProfessionDetailEditSchema = Yup.object().shape({
    Partner_education: Yup.array()
        .of(Yup.string()) // Ensures each item in the array is a string
        .notRequired(), // Makes the field optional
    partner_occupation: Yup.array()
        .of(Yup.string()) // Ensures each item in the array is a string
        .notRequired(),
    partnerIncome: Yup.number()
        .positive('Income must be positive') // Keeps validation for positive numbers
        .notRequired(), // Makes the field optional
    partner_residingCountry: Yup.array()
        .of(Yup.string()) // Ensures each item in the array is a string
        .notRequired(),
    partner_residingState: Yup.array()
        .of(Yup.string()) // Ensures each item in the array is a string
        .notRequired(),
    partner_residingCity: Yup.array()
        .of(Yup.string()) // Ensures each item in the array is a string
        .notRequired(),
});

export const partnerNativeLocationEditSchema = Yup.object().shape({

    partnerCountry: Yup.array()
        .of(Yup.string()) // Ensures each item in the array is a string
        .notRequired(),
    partnerState: Yup.array()
        .of(Yup.string()) // Ensures each item in the array is a string
        .min(1, 'Select at least one Residing State').required('State is required'),
    partnerCity: Yup.array()
        .of(Yup.string()) // Ensures each item in the array is a string
        .notRequired(),
    partnerCitizenship: Yup.array()
        .of(Yup.string()) // Ensures each item in the array is a string
        .notRequired(),
});

export const partnerReligionSocialPreferenceEditSchema = Yup.object().shape({
    partnerDomain: Yup.array().of(Yup.string()).notRequired(),
    partnerReligion: Yup.array().of(Yup.string()).notRequired(),
    partnerCaste: Yup.array().of(Yup.string()).notRequired()
    // What_I_am_Looking_For: Yup.string().required('This field is required'),
});

export const partnerLifestyleAppearanceDetailEditSchema = Yup.object().shape({
    partner_eating_Habits: Yup.array()
        .of(Yup.string()) // Ensures each item in the array is a string
        .notRequired(),
    partnerComplexion: Yup.array()
        .of(Yup.string()) // Ensures each item in the array is a string
        .notRequired(),
    // partner_physical_status: Yup.string().required('Partner Physical is required'),
    partner_drinking_habits: Yup.string().notRequired(), // Ensures each item in the array is a string,
    partner_smoking_habits: Yup.string().notRequired(),
});

export const familyDetailEditSchema = Yup.object().shape({
    familyValue: Yup.string().required('Family Value is required'),
    familyType: Yup.string().required('Family Type is required'),
    familyStatus: Yup.string().required('Family Status is required'),
    fatherName: Yup.string().required('Father’s Name is required'),
    fatherProfessions: Yup.string().notRequired(),
    motherName: Yup.string().required('Mother’s Name is required'),
    motherProfession: Yup.string().notRequired(),
    marriedSister: Yup.string().notRequired(),
    unMarriedSister: Yup.string().notRequired(),
    marriedBrothers: Yup.string().notRequired(),
    unMarriedBrothers: Yup.string().notRequired(),
    familyOrigin: Yup.string().notRequired(),
    aboutFamily: Yup.string().notRequired()
});
export const hobbiesEditSchema = Yup.object().shape({
    hobbies: Yup.array()
        .of(Yup.string()) // Ensures each item in the array is a string
        .notRequired()
});

export const aboutLifePartnerEditSchema = Yup.object().shape({
    aboutLifePartner: Yup.string().notRequired()
});

export const uploadImageSchema = Yup.object().shape({
    photos: Yup.array()
        .of(
            Yup.mixed()
                .required('At least one file is required')
                .test('fileSize', 'File too large', value => !value || value.size <= 10485760) // 10 MB
                .test('fileType', 'Unsupported file format', value => !value || ['image/jpeg', 'image/png'].includes(value.type))
        )
        .required('At least one file is required')
});

export const changePasswordValidationSchema = Yup.object().shape({
    old_password: Yup.string().required('Current password is required'),
    new_password: Yup.string()
        .min(8, 'New password must be at least 8 characters')
        .matches(/[A-Z]/, 'New password must contain at least one uppercase letter')
        .matches(/[a-z]/, 'New password must contain at least one lowercase letter')
        .matches(/[0-9]/, 'New password must contain at least one number')
        .matches(/[!@#$%^&*(),.?":{}|<>]/, 'New password must contain at least one special character')
        .required('New password is required'),
    confirm_password: Yup.string()
        .oneOf([Yup.ref('new_password'), null], 'Passwords must match')
        .required('Confirm new password is required'),
});

export const deleteProfileValidationSchema = Yup.object().shape({
    delete_reason: Yup.string().required('Delete Reason is Required'),
});

export const verifyOTPValidationSchema = Yup.object().shape({
    otp: Yup.string()
        .length(6, 'OTP must be exactly 6 digits')
        .matches(/^\d{6}$/, 'OTP must be a 6-digit number')
        .required('OTP is required'),
})

export const mobileValidationSchema = Yup.object().shape({
    username: Yup.string()
        .required('Mobile Number is required')
        .matches(/^\d{10}$/, 'Must be a valid 10-digit mobile number'),
});


export const verifyOTPValidationSchemas = Yup.object({
    username: Yup.string().required('Mobile number is required'),
    otp: Yup.string().required('OTP is required').length(6, 'OTP must be 6 digits'),
    password: Yup.string().required('Password is required'),
    confirm_password: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Confirm password is required'),
});

export const panValidationSchema = Yup.object({
    apiKey: Yup.string().required('API Key is required'),
    requested_orderId: Yup.string().required('Order ID is required'),
    customer_pan_number: Yup.string().required('PAN Number is required'),
    service_id: Yup.string().required('Service ID is required'),
    consent_text: Yup.string().required('Consent is required'),
    name_to_match: Yup.string().required('Name is required'),
});

export const aadhaarOtpRequestSchema = Yup.object({
    apiKey: Yup.string().required('API Key is required'),
    requested_orderId: Yup.string().required('Order ID is required'),
    customer_aadhaar_number: Yup.string()
        .required('Aadhaar Number is required')
        .length(12, 'Aadhaar Number must be 12 digits'),
    service_id: Yup.string().required('Service ID is required'),
    consent_text: Yup.string().required('Consent is required'),
    name_to_match: Yup.string().required('Name is required'),
});

export const aadhaarOtpVerificationSchema = Yup.object({
    apiKey: Yup.string().required('API Key is required'),
    requested_orderId: Yup.string().required('Order ID is required'),
    request_id: Yup.string().required('Request ID is required'),
    service_id: Yup.string().required('Service ID is required'),
    task_id: Yup.string().required('Task ID is required'),
    otp: Yup.string()
        .required('OTP is required')
        .length(6, 'OTP must be 6 digits'),
    consent_text: Yup.string().required('Consent is required'),
});

export const kycValidationSchema = Yup.object({
    selectedID: Yup.string().required("ID type is required"),
    idNumber: Yup.string().when("selectedID", (selectedID, schema) => {
        if (selectedID[0] === "PAN") {
            return schema
                // .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Enter a valid PAN number")
                .required("PAN number is required");
        }
        return schema
            .matches(/^\d{12}$/, "Enter a valid 12-digit Aadhar number")
            .required("Aadhar number is required");
    }),
    confirmation: Yup.boolean()
        .oneOf([true], "You must confirm the details")
        .required("Confirmation is required"),
});

export const resetPasswordValidationSchema = Yup.object({
    password: Yup.string().required('Password is required')
        .min(8, 'Password must be at least 8 characters long')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/[0-9]/, 'Password must contain at least one number')
        .matches(/[@$!%*?&#]/, 'Password must contain at least one special character'),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Confirm Password is required'),
});

export const camapignValidationSchema = Yup.object().shape({
    name: Yup.string().required("First Name is required"),
    last_name: Yup.string().required("Last Name is required"),
    phone: Yup.string()
        .matches(/^[0-9]{10}$/, "Phone must be 10 digits")
        .required("Phone number is required"),
    gender: Yup.string().required("Gender is required"),
    date_of_birth: Yup.date()
        .required('Date of Birth is required')
        .max(
            new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
            'You must be at least 18 years old'
        ),
    maritalStatus: Yup.string().required("Marital Status is required"),
    education: Yup.string().required("Education is required"),
    occupation: Yup.string().required("Profession is required"),
    terms: Yup.bool().oneOf([true], 'You must accept the terms of registration'),
});